import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// 3rd party module
import { AngularSplitModule } from 'angular-split';
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

import {
    DxBoxModule,
    DxResponsiveBoxModule,
    DxTextBoxModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxTextAreaModule,
    DxScrollViewModule,
    DxSwitchModule,
    DxSelectBoxModule,
    DxDropDownBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxDateBoxModule,
    DxFormModule,
    DxToolbarModule,
    DxTreeListModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    DxDrawerModule,
    DxProgressBarModule,
    DxMenuModule,
    DxListModule,
    DxRadioGroupModule
} from 'devextreme-angular';
import { ImageCropperModule } from 'ngx-image-cropper';
import { WebcamModule } from 'ngx-webcam';

import { SharedModule } from '../shared-module/shared.module';
import { NotesEditorComponent } from './component/common/notes-editor/notes-editor.component';
import { NotesViewerComponent } from './component/common/notes-viewer/notes-viewer.component';
import { MultiColumnSelectorComponent } from './component/common/multi-column-selector/multi-column-selector.component';
import { ViewHistoryComponent } from './component/common/view-history/view-history.component';
import { SaveTemplateComponent } from './component/common/save-template/save-template.component';
import { PropertyCommunityDocumentsComponent } from './component/common/property-community-documents/property-community-documents.component';
import { AttachmentEditorComponent } from './component/common/attachments/attachment-editor/attachment-editor.component';
import { AttachmentSelectorComponent } from './component/common/attachments/attachment-selector/attachment-selector.component';
import { GridCellMultiColumnSelectorComponent } from './component/common/grid-cell-multi-column-selector/grid-cell-multi-column-selector.component';
import { AttachmentUploaderComponent } from './component/common/attachments/attachment-uploader/attachment-uploader.component';
import { MultiColumnMultipleSelectorComponent } from './component/common/multi-column-multiple-selector/multi-column-multiple-selector.component';
import { MultiUserBioLinksComponent } from './component/common/multi-user-bio-links/multi-user-bio-links.component';
import { ImageEditorComponent } from './component/common/image-editor/image-editor.component';
import { AttorneyVendorsSelectorComponent } from './component/common/attorney-vendors-selector/attorney-vendors-selector.component';
import { NotesGridEditorComponent } from './component/common/notes-grid-editor/notes-grid-editor.component';
import { NoteViewEditComponent } from './component/common/note-view-edit/note-view-edit.component';

@NgModule({
    declarations: [
        NotesEditorComponent,
        NotesViewerComponent,
        MultiColumnSelectorComponent,
        ViewHistoryComponent,
        SaveTemplateComponent,
        PropertyCommunityDocumentsComponent,
        AttachmentSelectorComponent,
        AttachmentEditorComponent,
        GridCellMultiColumnSelectorComponent,
        AttachmentUploaderComponent,
        MultiColumnMultipleSelectorComponent,
        MultiUserBioLinksComponent,
        ImageEditorComponent,
        AttorneyVendorsSelectorComponent,
        NotesGridEditorComponent,
        NoteViewEditComponent
    ],
    exports: [
        NotesEditorComponent,
        NotesViewerComponent,
        MultiColumnSelectorComponent,
        ViewHistoryComponent,
        SaveTemplateComponent,
        PropertyCommunityDocumentsComponent,
        AttachmentSelectorComponent,
        AttachmentEditorComponent,
        GridCellMultiColumnSelectorComponent,
        AttachmentUploaderComponent,
        MultiColumnMultipleSelectorComponent,
        MultiUserBioLinksComponent,
        ImageEditorComponent,
        AttorneyVendorsSelectorComponent,
        NotesGridEditorComponent
    ],
    imports: [
        ImageCropperModule,
        WebcamModule,
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        AngularSplitModule,
        DxBoxModule,
        DxResponsiveBoxModule,
        DxTextBoxModule,
        DxValidationGroupModule,
        DxValidatorModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxTextAreaModule,
        DxScrollViewModule,
        DxSwitchModule,
        DxSelectBoxModule,
        DxDropDownBoxModule,
        DxDataGridModule,
        DxPopupModule,
        DxDateBoxModule,
        DxFormModule,
        DxToolbarModule,
        DxTreeListModule,
        DxFileUploaderModule,
        DxDropDownButtonModule,
        DxDrawerModule,
        DxProgressBarModule,
        DxMenuModule,
        DxListModule,
        DxRadioGroupModule,
        SharedModule,
        CCDataGridFeaturesModule
    ]
})
export class ManagementCommonModule {}
